import { Injectable } from '@angular/core';
import { HttpClientService } from '../../client/http-client/http-client.service';
import { ApiConstants } from '../../constants/api.constants';
import { catchError, map, throwError } from 'rxjs';
import {
  DeleteTimesheetLineRequestParams,
  InsertTimesheetHeaderRequestParams,
  InsertTimesheetHeaderResponse,
  InsertTimesheetLineRequestParams,
  InsertTimesheetLineResponse,
  TimesheetLineRoot,
  TimesheetRoot,
} from '../../domain/timesheets-domain';

@Injectable({
  providedIn: 'root',
})
export class TimesheetsService {
  constructor(private httpClient: HttpClientService) {}

  fetchTimesheetHeaders() {
    return this.httpClient.get<TimesheetRoot>(ApiConstants.TIMESHEET_LIST_API_URL).pipe(map((res) => res));
  }

  fetchTimesheetLines() {
    return this.httpClient.get<TimesheetLineRoot>(ApiConstants.TIMESHEET_LINE_LIST_API_URL).pipe(map((res) => res));
  }

  insertTimesheetHeader(body: InsertTimesheetHeaderRequestParams) {
    return this.httpClient.post<InsertTimesheetHeaderRequestParams, InsertTimesheetHeaderResponse>(ApiConstants.INSERT_TIMESHEET_HEADER_URL, body).pipe(
      map((res) => res),
      catchError((error) => {
        console.error('[Timesheets] Failed to create timesheet header:', error);
        return throwError(() => error);
      }),
    );
  }

  insertTimesheetLine(body: InsertTimesheetLineRequestParams) {
    return this.httpClient.post<InsertTimesheetLineRequestParams, InsertTimesheetLineResponse>(ApiConstants.INSERT_TIMESHEET_LINE_URL, body).pipe(map((res) => res));
  }

  updateTimesheetLine(body: InsertTimesheetLineRequestParams) {
    return this.httpClient
      .patch<InsertTimesheetLineRequestParams, InsertTimesheetLineResponse>(`${ApiConstants.PATCH_TIMESHEET_LINE_URL}(${body.entryNo},'${body.timesheetNo}')`, body)
      .pipe(map((res) => res));
  }

  deleteTimesheetLine(body: DeleteTimesheetLineRequestParams) {
    return this.httpClient.delete(`${ApiConstants.DELETE_TIMESHEET_LINE_URL}(${body.entryNo},'${body.timesheetNo}')`).pipe(map((res) => res));
  }
}
